import { KdsDivider, KdsText } from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";

import { OrderItemGetOrderItemLogsOrderLogReadDtoActionTypeEnum } from "@/config/apiClient";
import { useOrderItems } from "@/hooks";
import { type OrderItemPageActivityFeedProps } from "./OrderItemPageActivityFeed.types";
import { OrderItemPageActivityLog } from "./OrderItemPageActivityLog";

export const OrderItemPageActivityFeed = ({
  orderId,
  orderItemId,
}: OrderItemPageActivityFeedProps) => {
  const { t } = useTranslate();

  const { useGetOrderItemLogs } = useOrderItems();
  const { data: historicRecords } = useGetOrderItemLogs({
    orderId,
    orderItemId,
  });

  const orderItemLogs = historicRecords?.data;

  return (
    <div className="flex flex-col gap-sp-xs">
      <div className="flex items-center gap-[10px] p-sp-xs2 pb-sp-md">
        <div className="whitespace-nowrap">
          <KdsText size="subtitle-xs">
            {t("order.myOrdersItemDetails.activityFeed.title")}
          </KdsText>
        </div>

        <KdsDivider />
      </div>

      {orderItemLogs
        ?.filter(
          (orderItemLog) =>
            orderItemLog.actionType !==
            OrderItemGetOrderItemLogsOrderLogReadDtoActionTypeEnum.Done
        )
        .map((orderItemLog, index) => (
          <OrderItemPageActivityLog
            key={orderItemLog.id}
            orderItemLog={orderItemLog}
            orderItemId={orderItemId}
            orderId={orderId}
            isChatAreaOpen={index === 0}
          />
        ))}
    </div>
  );
};
